// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_16f4dQQDBy-0kkiS3FVKdZ"};